<template>
	<v-system-bar
			class="customVSystemBar"
			absolute
			color="error"
			dark>
		<v-row	class="row_"
				align="center"
				justify="center"
				no-gutters>
			<v-col class="center" cols="auto">
				<template v-if="env.dev"><span class="caption">DEV</span></template>
				<template v-if="env.qa"><span class="caption">QA</span></template>
			</v-col>
		</v-row>
	</v-system-bar>
</template>

<script>
	export default {
		name: 'EnvInfoSystemBar',
		data() {
			return {
				componentName_: 'envInfoSystemBar'
			}
		}
	}
</script>

<style scoped>
	.row_ {
		max-height: 24px !important;
	}
</style>
